import { Component, OnDestroy } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-safari-add-home-screen-sheet",
  templateUrl: "./safari-add-home-screen-sheet.component.html",
  styleUrls: ["./safari-add-home-screen-sheet.component.scss"],
  standalone: true,
  imports: [IonicModule, MatIcon, TranslatePipe],
})
export class SafariAddHomeScreenSheetComponent implements OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();

  public readonly steps = [
    {
      image: "assets/icon/share-icon.svg",
      titleKey: "safari-add-home-screen.step1_title",
      bodyKey: "safari-add-home-screen.step1_body",
    },
    {
      image: "assets/icon/home_active.svg",
      titleKey: "safari-add-home-screen.step2_title",
      bodyKey: "safari-add-home-screen.step2_body",
    },
    {
      image: "assets/icon/home_active.svg",
      titleKey: "safari-add-home-screen.step3_title",
      bodyKey: "safari-add-home-screen.step3_body",
    },
  ];

  constructor(
    private matRef: MatBottomSheetRef<SafariAddHomeScreenSheetComponent>,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (language: string) => {
        if (language) {
          translate.use(language);
        }
      },
      error: (err) => err,
    });
  }

  close(): void {
    this.matRef.dismiss();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
